/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
	Form, Input, Button
} from 'antd';
import { bool, func } from 'prop-types';
import { validateMessages } from '../../utils/validateMessages';

const layout = {
	labelCol: {
		span: 6
	},
	wrapperCol: {
		span: 12
	}
};

const ResetPasswordForm = ({ onSubmit, isLoading }) => (
	<Form {...layout}
		onFinish={onSubmit}
		validateMessages={validateMessages}
		labelCol={{ span: 12, offset: 0 }}
		wrapperCol={{ span: 24 }}
		layout={"vertical"}
		name="nest-messages">
		<Form.Item
			name={['newPassword']}
			label="Contraseña"
			rules={[
				{
					required: true,
				}
			]}
		>
			<Input />
		</Form.Item>
		<Form.Item
			name={['passwordConfirmation']}
			label="Confirme su contraseña"
			dependencies={['newPassword']}
			rules={[
				{
					required: true,
					message: 'Confirme su contraseña, por favor',
				},
				({ getFieldValue }) => ({
					validator(_, value) {
						if (!value || getFieldValue('newPassword') === value) {
							return Promise.resolve();
						}
						return Promise.reject(new Error('Las contraseñas deben coincidir'));
					},

				}),
			]}
		>
			<Input />
		</Form.Item>


		<Form.Item wrapperCol={{ ...layout.wrapperCol }} style={{ justifyContent: 'center' }}>
			<Button type="primary" htmlType="submit" block size="large" loading={isLoading}>
				Aceptar
			</Button>
		</Form.Item>


	</Form>
);

ResetPasswordForm.propTypes = {
	onSubmit: func.isRequired,
	isLoading: bool
};

ResetPasswordForm.defaultProps = {
	isLoading: false
};

export default ResetPasswordForm;
